import React, {useEffect, useState} from 'react';
import AppContainer from "../../containers/Container/App/Main";
import SimpleTabs from "../../containers/Tab/SimpleTabs";
import CompetencyCategoryTable from "../Competencies/Admin/CompetencyCategoryTable";
import CompetencyTable from "../Competencies/Admin/CompetencyTable";
import CompetencyCompetencyCategoryTable from "../Competencies/Admin/CompetencyCompetencyCategoryTable";
import {useStore} from "../../stores/store";
import {setupCrud} from "../../helpers/setupCrud";
import {allowEdit} from "../../helpers/allowEdit";
import {useHistory} from "react-router-dom";

const AdminCompetency = (props) => {
  const {path} = props;
  const {state} = useStore();
  const [crud, setCrud] = useState([]);
  const [crudAllowed, setCrudAllowed] = useState([]);
  let newTab = [];
  let history = useHistory();

  useEffect(() => {
    setCrud(setupCrud(path, state.user_data.menu.admin));

    if (typeof state.user_data.menu.settings !== 'undefined') {
      state.user_data.menu.settings.map((tab, id) => {
        if (tab.menu_id_parent === 5) {
          newTab[tab.code] = tab;
          setCrudAllowed(newTab);
        }
      })
    }

  }, [state.user_data.menu_updated]);

  if (typeof crudAllowed['COMPETENCIES-LIST'] == 'undefined') return null;

  if(typeof crud.read !== 'undefined' && !crud.read) {
    history.push("/404");
  }

  return (
    <AppContainer>
      <SimpleTabs>
        <CompetencyTable
          title={'Competencies List'}
          crudAllowed={crudAllowed['COMPETENCIES-LIST'].crud}
          visible={crudAllowed['COMPETENCIES-LIST'].crud.read}
        />
        <CompetencyCategoryTable
          title={'Competency Category'}
          crudAllowed={crudAllowed['COMPETENCY-CATEGORY'].crud}
          visible={crudAllowed['COMPETENCY-CATEGORY'].crud.read}
        />
        <CompetencyCompetencyCategoryTable
          title={'Competency Competency Category'}
          crudAllowed={crudAllowed['COMPETENCY-COMPETENCY-CATEGORY'].crud}
          visible={crudAllowed['COMPETENCY-COMPETENCY-CATEGORY'].crud.read}
        />
      </SimpleTabs>
    </AppContainer>
  )
};

export default AdminCompetency;